<template>
  <component :is="layout">
    <router-view/>
  </component>
</template>

<script>

import AppLayoutPrivate from './AppLayoutPrivate'
import AppLayoutDefault from './AppLayoutDefault'
export default {
 components:{
  AppLayoutDefault,
  AppLayoutPrivate,
 },
  computed: {
    layout () {
      return (this.$route.meta.layout || AppLayoutDefault)
    }
  },
}
</script>